export default "__VITE_ASSET__BiHGj$qX__"